import { render, staticRenderFns } from "./AirwallexDialog.vue?vue&type=template&id=381c206f&scoped=true"
import script from "./AirwallexDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AirwallexDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AirwallexDialog.vue?vue&type=style&index=0&id=381c206f&lang=scss&scoped=true"
import style1 from "./AirwallexDialog.vue?vue&type=style&index=1&id=381c206f&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381c206f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/joinmc-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('381c206f')) {
      api.createRecord('381c206f', component.options)
    } else {
      api.reload('381c206f', component.options)
    }
    module.hot.accept("./AirwallexDialog.vue?vue&type=template&id=381c206f&scoped=true", function () {
      api.rerender('381c206f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AirwallexDialog.vue"
export default component.exports